import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';
import { ApiListResponse } from '@/shared/models/api-response.interface';
import { Publication } from '../models/publication.model';

@Injectable({
  providedIn: 'root',
})
export class PublicationService {
  constructor(private httpClient: HttpClient) {}

  get headers() {
    return {
      Accept: 'application/json',
    };
  }

  getPublications(
    page: number = 0,
    size: number = 10,
    insaeCode: string | null = null,
    startDate: string | null = null,
    endDate: string | null = null
  ): Observable<ApiListResponse<Publication>> {
    const params = new URLSearchParams({
      page: page.toString(),
      size: size.toString(),
      ...(!startDate && !endDate
        ? (() => {
            const end = new Date();
            const start = new Date();
            start.setDate(end.getDate() - 15);
            return {
              startDate: start.toISOString().slice(0, 10),
              endDate: end.toISOString().slice(0, 10),
            };
          })()
        : {
            ...(startDate ? { startDate } : {}),
            ...(endDate ? { endDate } : {}),
          }),
    });

    if (insaeCode) {
      params.append('insaeCode', insaeCode);
    }

    return this.httpClient.get<ApiListResponse<Publication>>(
      `${environment.ENGINE_API_URL}/announcements/ccdf?${params.toString()}`,
      { headers: this.headers }
    );
  }

  getPublication(id: number): Observable<Publication> {
    return this.httpClient.get<Publication>(`
      ${environment.ENGINE_API_URL}/announcements/ccdf/${id}
    `);
  }
}
